/** How long a visit lasted, or `activeLabel` while the climber is still in. */
export function formatDuration(
  checkedInAt: string,
  checkedOutAt: string | null,
  activeLabel: string,
): string {
  if (!checkedOutAt) return activeLabel
  const ms = new Date(checkedOutAt).getTime() - new Date(checkedInAt).getTime()
  const totalMinutes = Math.floor(ms / 60000)
  if (totalMinutes < 1) return '<1m'
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  if (hours === 0) return `${minutes}m`
  if (minutes === 0) return `${hours}h`
  return `${hours}h ${minutes}m`
}
